import React from 'react';

const Layout: React.FC = (props) => {
	return <div>{props.children}</div>;
};

export default Layout;
